import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { AppUser, PointOfSale, WaitingNote } from '../order/waiting-notes/waitingnotes.component';
import { AuthService } from 'src/app/services/auth/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { QRCodeService } from 'src/app/services/qrcode/qrcode.service';
import { DecodedToken } from 'src/app/services/qrcode/qrcode.service';
import {ContextAppService} from "../../services/context-app-service";
import { normalizePos, PointOfSaleDetails } from 'src/app/services/api/fulle/fulle-pointOfSale/fulle-pointOfSale.service.interface';

interface ApiResponse {
  code: number;
  list: WaitingNote[];
}

@Component({
  selector: 'app-home-interface',
  templateUrl: './home-interface.component.html',
})
//TODO rajouter le numéro de table si spécifié
export class HomeInterfaceComponent implements OnInit {

  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    private authService: AuthService,
    private route: ActivatedRoute,
    private http: HttpClient,
    private router: Router,
    public translate: TranslateService,
    public contextAppService: ContextAppService,
    private af: AngularFireAuth,
    private qrcodeservice: QRCodeService,
  ) { }

  isLoading = true;
  pointOfSale: PointOfSaleDetails | null = null; // Point de vente actif (renseigné par le code dans l'URL).
  user: AppUser | null = null; // Stocke les informations de l'utilisateur connecté (Firebase).
  currentIdWebshop: string | number | null = null; // Identifiant du Webshop courant (utile pour l'API).
  urlBase = environment.apiUrl; // Stocke l'url.
  idUser = this.route.snapshot.params['user_id']; // Paramètre de la route, pour identifier l'userId.
  tableNumber = this.route.snapshot.params['table_id']; // Paramètre de la route, pour identifier la table (le numéro de table en cours).
  showCommander = false;
  showPayer = false;
  shortUrlOrderCode: string | null = null;
  shortUrlMenuCode: string | null = null;
  paymentRoute: any;
  buttonsReady = false;
  decodedPayload: DecodedToken = {
    route: 'qrcode',
    id: 0,
    code: '',
    table: 0,
  };
  posBanner = "/assets/img/waiting-notes/bg_banner2.png"
  routeParams : any = null

  async ngOnInit(): Promise<void> {

    // Params de la route
    this.routeParams = this.route.snapshot.params

    const merchantName = this.routeParams['merchantName'];
    const webshopId = this.routeParams['webshopId'];

    //TODO tout le temps passer par la
    if(merchantName && webshopId){
      // console.log("merchantName && webshopId", merchantName, " ", webshopId);
    }
    /*else if (token) {
      try {
        this.decodedPayload = this.qrcodeservice.decodeToken(token);
      } catch (e) {
        console.error('Erreur de décodage du token :', e);
        this.router.navigate(['/404']);
        return;
      }
    } */
    else {
      // Si aucun token, on suppose qu'on passe les infos en clair via les params
      const userId = this.route.snapshot.params['user_id'];
      const code = this.route.snapshot.params['code'];
      const table = this.route.snapshot.params['table_id'];

      if (!userId || !code || !table) {
        this.router.navigate(['/404']);
        return;
      }

      this.decodedPayload = {
        id: Number(userId),
        code: code,
        table: Number(table),
        route: 'qrcode',
      };
    }

    this.getClient();

    try {
      await this.getPointOfSale();
      if (this.pointOfSale){

        // Banniere du point de vente
        /*if(this.pointOfSale.banner && this.pointOfSale.banner.length > 0){
          this.posBanner = this.pointOfSale.banner[3]
        }*/

        await this.initButtons();
      }
    }
    catch (error) {
      this.onError("ngOnInit", error);
    }
    finally {
      this.isLoading = false;
    }
  }

  onError(place: string, error: unknown): void {
    if (error instanceof Error) {
      console.error(place, ":", error.message);
    } else {
      console.error(place, ":", error);
    }
    // this.stopAutoRefresh();
  }

  getClient() {
    this.authService.getUser.subscribe((user: AppUser) => {
      if (user) {
        // Compte client final
        this.user = user;
      }
    });
  } // Methode pour récupérer le client connecté (facultatif n'est la que pour des eventuels cartes de fidelites, etc...)

  async getPointOfSale() {
    this.pointOfSale = normalizePos(this.contextAppService.currentPointOfSale);
  }

  getStor<T>(key: string): T | null {
    if (isPlatformBrowser(this.platformId)) {
      const item = sessionStorage.getItem(key);
      return item && item !== "undefined" ? JSON.parse(item) as T : null;
    }
    return null;
  }

  async getBaseApi<T>(endpoint: string, params: Record<string, unknown> = {}): Promise<T> {
    const id_webshop = typeof params['id_webshop'] === 'string'
      ? params['id_webshop']
      : this.getStor<PointOfSale>("point_of_sale")?.id_webshop ?? "";
    this.currentIdWebshop = id_webshop;
    const queryParams = new URLSearchParams();

    for (const [key, value] of Object.entries(params)) {
      if (value !== undefined && value !== null) {
        queryParams.set(key, String(value));
      }
    }

    if (!params['id_webshop'] && id_webshop) {
      queryParams.set('id_webshop', String(id_webshop));
    }

    const url = `${this.urlBase}${endpoint}?${queryParams.toString()}`;

    try {
      const res = await this.http.get<T>(url).toPromise();
      return res as T;
    } catch (err) {
      this.onError('API error:', err);
      throw err;
    }
  }

  // async getPointOfsaleById(posId: string): Promise<PointOfSale> {
  //   // const pos = await this.getBaseApi<PointOfSale>("custom/point_of_sale", { id_webshop: posId });
  //   const pos = await this.getBaseApi<PointOfSale[]>("custom/point_of_sale_by_user_id", { id_user: 87141 });
  //   // console.log("pos : ", pos)

  //   if (!pos) {
  //     this.router.navigate(["/404", this.translate.instant('error404.noPof')], { skipLocationChange: true });
  //   }
  //   // console.log("pos custom avec posId : ", posId, "donne : ", pos)
  //   return pos[0];
  // }

  async getWaitingNotes(params: { id_pos: number }): Promise<ApiResponse> {
    const token = await this.getIdToken();
    const httpParams = new HttpParams()
      .set('id_pos', params.id_pos);
    const note = await this.http.get<ApiResponse>(this.urlBase + 'waiting-notes', {
      headers: { Authorization: token },
      params: httpParams
    }).toPromise();

    if (!note) { throw new Error('Aucune note reçue du serveur.'); }
    return note;
  }

  async getIdToken(): Promise<string> {
    const user = await this.af.currentUser;
    return user?.getIdToken(false) ?? "invalid_token";
  }

  /**
   * Vérification de l'existence d'une option active chez un commerçant
   * @param idOption
   */
  async checkUserOption(idOption: number): Promise<{ exists: boolean; expiration?: string }> {
    try {
      const res = await this.getBaseApi<{ exists: boolean; expiration?: string }>('user-options/check', {
        'id_webshop': this.routeParams['webshopId'],
        'id_option[]': [idOption],
      });
      // console.log("res :", res)
      return res;
    } catch (error) {
      this.onError('checkUserOption', error);
      return { exists: false };
    }
  }

  async getShortUrlsCode(idPointOfSale: number, type: number): Promise<string | null> {
    try {
      const res = await this.getBaseApi<{ code: string | null }>('get-short-urls-code', {
        id_point_of_sale: idPointOfSale,
        type: type,
      });
      if (!res.code) return null;
      return res.code;
    } catch (error) {
      this.onError('checkUserOption', error);
      return null;
    }
  }

  private async initButtons() {
    try {
      const pos = this.pointOfSale;
      if (!pos){
        console.error("!pos");
        return;
      }

      // Identifiant mode de vente
      const smId = parseInt(this.routeParams['smId']);

      // Identifiant information de note
      const locId = parseInt(this.routeParams['locId']);

      // Valeur information de note
      const locValue = parseInt(this.routeParams['locValue']);

      // Option Commande à la table ?
      const hasCommander = await this.checkUserOption(38);

      // Option Paiement à la table ?
      const hasPayer = await this.checkUserOption( 45);

      // Si option Commande à la table + le point de vente accepte la commande à la table
      if (hasCommander.exists && pos.enableOrderIntent === 1) {

        this.shortUrlOrderCode = null;

        // Identifiant mode de vente pour la commande à table (obligatoire)
        if(smId > 0){

          // On créé la route pour accéder à l'interface de commande, avec le mode de vente et code point de vente
          this.shortUrlOrderCode = "/s/" + this.routeParams['merchantName'] + "/" + this.routeParams['webshopId'] + "/" + smId;

          // Numéro de table (optionnel)
          if(locId > 0 && locValue > 0){
            this.shortUrlOrderCode += "/" + locId + "/" + locValue;
          }
        }

        this.showCommander = !!this.shortUrlOrderCode;
      }

      // Menu (seulement si on n'affiche pas le bouton Commander)
      if (!this.showCommander) {
        this.shortUrlMenuCode = await this.getShortUrlsCode(pos.id, 2);
      }

      // Gestion du paiement à la table
      // L'option doit etre active + actif sur le point de vente
      if (hasPayer.exists && pos.enablePaymentNoteIntent === 1 && locValue > 0) {

        try {
          this.paymentRoute = "/note/" + this.routeParams['merchantName'] + "/" + this.routeParams['webshopId'] + "/" + locValue;
          this.showPayer = true;
        } catch (error) {
          this.onError("generateNoteUrl", error);
        }
      }
    } catch (error) {
      this.onError('initButtons', error);
    } finally {
      this.buttonsReady = true;
    }
  }

  goToPayment() {
    window.location.href = this.paymentRoute;
  }

  navigate(route : string): void {
    // console.log("navigate " + route);
    this.router.navigate([route]);
  }

  openShortUrl(code: string) {
    window.open(`https://shorturl.fulleapps.io/${code}`, "_blank");
  }
}
